require('./stylesheet/style.sass')
/**
 *  Module
 *
 * Description
 */
angular.module('pages.wrongBrowser', [])

.config(config)

config.$inject = ['$stateProvider']

function config($stateProvider) {

    $stateProvider
        .state('pages.wrongBrowser', {
            url: 'wrongBrowser',
            template: require('./templates/index.html'),
            pageTrack: '/wrongBrowser'
        });
}

module.exports = 'pages.wrongBrowser';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/wrongBrowser/index.js
 ** module id = 300
 ** module chunks = 1
 **/